<chart [type]="'polarArea'" [data]="polarData" [options]="polarOptions"></chart>